<ng-template #confirm_simple_modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    {{ body }}
  </div>
  <div class="modal-footer d-flex justify-content-end">
    <button type="button" class="btn secondary-button border-0" (click)="modal.close(false)">
      <label class="form_label_medium_style">CANCEL</label>
    </button>
    <button type="button" class="btn btn_heavenly_style border-0" (click)="modal.close(true)">
      <label class="form_label_medium_style">OK</label>
    </button>
  </div>
</ng-template>
